<main class="single-tab-blocker">
  <section class="single-tab-blocker__panel">
    <h1>{{ 'BLOCKED_VIEW_TITLE' | translate }}</h1>
    <p>{{ 'BLOCKED_VIEW_MESSAGE_LINE_1' | translate }}</p>
    <p>{{ 'BLOCKED_VIEW_MESSAGE_LINE_2' | translate }}</p>
  </section>
</main>